import React, { Component } from "react";
import Form from "../forms/Form";
import AppfetchOb from "./API_act_fetch";
import AppApi from "./API_handler";
import ItemsCarousel from "react-items-carousel";

// import pic1 from "../pics_carousal/About.png";
import pic1 from "../pics_carousal/blockView.png";
import pic2 from "../pics_carousal/nomenclature.png";
import pic3 from "../pics_carousal/tutorial.png";


class AppLand extends Component {
  constructor(props) {
    super(props);
    this.state = {
      post: {
        name: ""
      },
      jobs: [],
      showForm: true,
      activeItemIndex: 0,
      // autoplay: true
    };
  }

  componentDidMount() {
    // Start the autoplay timer when the component mounts
    this.startAutoplay();
  }

  componentWillUnmount() {
    // Clean up the autoplay timer when the component unmounts
    this.stopAutoplay();
  }

  startAutoplay = () => {
    // Set the autoplay timer to change the active item every 3 seconds
    this.autoplayTimer = setInterval(() => {
      const { activeItemIndex } = this.state;
      // Calculate the next active item index based on your logic
      const nextItemIndex = (activeItemIndex + 1) % 3;
      this.setState({ activeItemIndex: nextItemIndex });
    }, 3000); // Change the duration as desired
  }
  stopAutoplay = () => {
    // Clear the autoplay timer
    clearInterval(this.autoplayTimer);
  }

  changeActiveItem = (newIndex) => {
    // Stop the autoplay when the user manually changes the active item
    this.stopAutoplay();
    // Update the active item index
    this.setState({ activeItemIndex: newIndex });
  }

  //have 3 state variables, showForm will render the form, post(name) and jobs [] unknown

  handleChange = e => {
    const { name, value } = e.target;
    // console.log(name,value,'nameValue')
    this.setState(prevState => ({
      post: { [name]: value },
    }));

  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState(prevState => ({
      jobs: [prevState.post],
      showForm: false
    }));
  };

  example = e => {
    e.preventDefault();
    this.setState(prevState => ({
      jobs: [{ name: "56417" }],
      showForm: false
    }));
  };
  // changeActiveItem = activeItemIndex => this.setState({ activeItemIndex });

  render() {
    const { activeItemIndex } = this.state;
    let transslide = [];
    let leftIcon = (
      <i className="bi bi-caret-left-square p-0 mx-2" style={{ fontSize: "30px" }}></i>
    )
    let rightIcon = (
      <i className="bi bi-caret-right-square p-0 mx-2" style={{ fontSize: "30px" }}></i>
    )

    let ob1 = (
      <div className="card border-0" style={{
        borderRadius: "30% 60% 50% 20% / 30% 70% 50% 90%",
        background: 'linear-gradient(to right, #E9E9E9, #E8E8E8',
        padding: "1rem",
        margin: "1rem"
      }}>

        <div className="text-center small" style={{ padding: "2rem", margin: 2 }}  >
          <h5 style={{ padding: "1rem", margin: 0 }}>
            Exon Blocks
          </h5>
          <p className="text text-secondary">Primary and secondary visualization in exonic blocks</p>
        </div>
        <img src={pic1} style={{
          borderRadius: "100% 100% 100% 100% / 20% 20% 20% 20%",
          height: "90%", width: "90%", objectFit: "cover", margin: "0.5rem"
        }}
        ></img>
      </div >
    );
    let ob2 = (
      <div className="card border-0" style={{
        borderRadius: "30% 60% 50% 20% / 30% 70% 50% 90%",
        background: 'linear-gradient(to right, #E9E9E9, #E8E8E8',
        padding: "1rem",
        margin: "1rem"
      }}>
        <div className="text-center small" style={{ padding: "2rem", margin: 2 }} >
          <h5 style={{ padding: "1rem", margin: 0 }}> Nomenclature </h5>
          <p className="text text-secondary"> Brief overview of exon blocks and interpretation</p>
        </div>
        <img src={pic2} style={{
          borderRadius: "100% 100% 100% 100% / 20% 20% 20% 20%",
          height: "90%", width: "90%", objectFit: "cover", margin: "0.5rem"
        }}
        ></img>
      </div>
    );
    let ob3 = (
      <div className="card border-0" style={{
        borderRadius: "30% 60% 50% 20% / 30% 70% 50% 90%",
        background: 'linear-gradient(to right, #E9E9E9, #E8E8E8',
        padding: "2rem",
        margin: "2rem"
      }}>
        <div className="text-center small" style={{ padding: "2rem", margin: 2 }} >
          <h5 style={{ padding: "1rem", margin: 0 }}> Nightingale View </h5>
          <p className="text text-secondary"> Information rendered in views </p>
        </div>
        <img src={pic3} style={{
          borderRadius: "100% 100% 100% 100% / 20% 20% 20% 20%",
          height: "100%", width: "100%", objectFit: "cover", margin: "0.2rem"
        }}
        ></img>
      </div>
    );
    transslide.push(ob2)
    transslide.push(ob1)
    transslide.push(ob3)


    let exButton = (
      <div className="button">
        <button className="btn" onClick={this.example} style={{ background: "#a6a6a6", color: "White" }}>
          Example
        </button>
      </div>
    )

    // console.log("JOBS LOG",this.state.jobs)
    // const urlfetch = "http://172.16.3.146/nextrap/";
    // const urlfetch = "http://localhost:8001";
    // const urlfetch = "http://14.139.227.206/nextrap";

    const urlfetch = "https://www.iscbglab.in/enactdb";
    // const urlfetch = "http://172.16.46.73/enactdb/"
    // console.log("landingpage", urlfetch, this.state);
    if (this.state.showForm) {
      return (
        <div className="d-flex h-100" style={{
          paddingTop: "1rem",
          paddingBottom: "1rem",
          alignItems: "center", verticalAlign: "middle"
        }}>
          {/* alignItems: "center", verticalAlign: "middle",
          justify-content-center align-items-center" */}
          {/* style={{alignSelf: "center", alignItems: "center", borderStyle: "double",  borderColor: "blue"}} */}
          {/* child div 1 below */}
          <div className="d-flex w-50" style={{ margin: "0.2rem" }}>
            {/* this is not working */}
            <div>
              <Form
                handleChange={this.handleChange}
                post={this.state.post}
                handleSubmit={this.handleSubmit}
              />
              {exButton}
            </div>
          </div>
          {/* child div two below */}
          <div className="d-flex container-fluid w-50  " style={{
            // borderRadius: "50% 0% 0% 50% / 50% 0% 0% 50%",
            borderRadius: "20% 40% 50% 30% / 90% 45% 50% 30%",
            background: 'linear-gradient(to right, #E9E9E9, #E8E8E8',
            alignItems: "center"
            , margin: "0.2rem"
          }}>
            <div className="container-fluid p-5">
              <div>
                <ItemsCarousel
                  // Placeholder configurations
                  // Carousel configurations
                  numberOfCards={1}
                  gutter={10}
                  showSlither={false}
                  slidesToScroll={1}
                  firstAndLastGutter={false}
                  freeScrolling={false}
                  // Active item configurations
                  requestToChangeActive={this.changeActiveItem}
                  activeItemIndex={activeItemIndex}
                  activePosition={"center"}
                  chevronWidth={3}
                  rightChevron={<button className="btn p-0 m-1">{rightIcon}</button>}
                  leftChevron={<button className="btn p-0 m-1">{leftIcon}</button>}
                  outsideChevron={true}
                  infiniteLoop={true}
                >
                  {transslide}
                </ItemsCarousel>
              </div>
            </div>
          </div>
        </div >
      );
    } else {
      if (isNaN(this.state.jobs[0].name)) {
        // It will return true if not a number else false, means inside if its a string
        // console.log("insidestring funct", this.state.jobs[0], isNaN(this.state.jobs[0]));
        return (
          <div className="post-container">
            {this.state.jobs.map((job, index) => (
              <div key={index}>
                <AppApi
                  key={index}
                  urlprefix={urlfetch}
                  urlfetch={`${urlfetch}/name/${job.name}/`}
                />
              </div>
            ))}
          </div>
        );
      } else {
        // console.log("insidenumeric funct");
        return (
          <div className="post-container">
            {this.state.jobs.map((job, index) => (
              <div key={index}>
                <AppfetchOb
                  key={index}
                  urlfetch={`${urlfetch}/ncbid/${job.name}/`}
                />
              </div>
            ))}
          </div>
        );
      }
    }
  }
}

// text input to the form is added to state "post.name" and on click 
// this information added to the name varible then will be pushed to the jobs stack and then the showForm state will be toggled false.

// if added identifier will be alphabetical, then 
// isNaN(this.state.jobs[0].name) will be true and will go to first renedered block, and iwll try to fetch url with name job.name <component will be 'AppApi'
// otherwse if numerical then the else block , delaing here can be tricky as if url isnt fetched and other details, this componenet may go awry. coponent will be 'AppfetchOb'

export default AppLand;
